<template>
  <div class="flex w-full items-center justify-between">
    <div class="flex items-center space-x-2">
      <icon-base :icon="iconInfo.icon" :class="iconInfo.class" />
      <span class="text-headline">
        {{ emailActivityTypeOptions[modelValue] }}
      </span>
    </div>
    <icon-base v-if="isSelected" :icon="IconSent" class="text-blue-500" />
  </div>
</template>
<script setup lang="ts">
import { type Component, computed } from "vue";

import { emailActivityTypeOptions } from "@/helpers/constants/emails";

import IconIncomingArrow from "@/components/icons/IconIncomingArrow.vue";
import IconSent from "@/components/icons/email/IconSent.vue";
import IconBase from "@/components/ui/IconBase.vue";

interface Props {
  modelValue: "0" | "1";
  selected: string[];
}

const options: Record<Props["modelValue"], { icon: Component; class: string }> =
  {
    0: {
      icon: IconIncomingArrow,
      class: "text-turquoise",
    },
    1: {
      icon: IconIncomingArrow,
      class: "text-primary transform rotate-180",
    },
  };

const props = defineProps<Props>();

const isSelected = computed(() => !!props.selected?.includes(props.modelValue));

const iconInfo = computed(() => options[props.modelValue]);
</script>
